import { Controller } from "react-hook-form"
import { ContactForm, useHookForm } from "../../../services"
import { ContactUsFormData, DefaultFormState, FormState } from "../../../types"
import { useState } from "react"
import { Notifications } from "../../molecules"
import { t } from "../../../utils"
import { getValue } from "@mui/system"

const defaultValues: ContactUsFormData = {
    name: "",
    mobile: "",
    email: "",
    message: "",
    acceptedPromotionMails: 0
}

export const ContactUs = () => {
    window.scrollTo(0, 0);
    const [formState, setFormState] = useState<FormState>({ ...DefaultFormState });

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        reset
    } = useHookForm<ContactUsFormData>({ defaultValues })

    const acceptedPromotionMails = watch('acceptedPromotionMails');

    const onSubmitItem = async (data: ContactUsFormData) => {
        if(!data.acceptedPromotionMails) return;
        try {
            const response = await ContactForm.createContactUs(data);
            setFormState(prev => {
                reset(defaultValues)
                return {
                    ...prev,
                    loading: false,
                    notificationOpen: true,
                    formSubmitted: true,
                    ...(response.status ? { notificationMessage: t.successMessage } : { notificationType: t.errorMessage }),
                    ...(response.status ? { notificationType: 'success' } : { notificationType: 'error' }),
                }
            });
        } catch (error) {
            setFormState(prev => {
                return {
                    ...prev,
                    loading: false,
                    notificationOpen: true,
                    notificationType: 'error',
                    notificationMessage: t.errorMessage
                }
            })
        }
    }

    const onSubmit = () => handleSubmit(onSubmitItem)();

    return (<>
        <div className="contact-us">
            <section>
                <div className="container">
                    <div className="text-white   row">
                        <div
                            data-aos="fade-up"
                            className="px-4 px-md-5 mb-5 col-md-5 aos-init aos-animate"
                        >
                            <div className="d-flex flex-column ">
                                <h1 className="fw-bold fs-md-48 fs-40 mb-4">Get in touch</h1>
                                <div className="d-inline-flex mb-4">
                                    <img
                                        src="https://cms.growpital.com/uploads/map_mark_2b7260132c.svg"
                                        alt=""
                                        className="img-fluid me-3 mb-4"
                                    />
                                    <p className="ms-1">
                                        Mughlaha, Medical Road, Gorakhpur,
                                        273013
                                    </p>
                                </div>
                                <div className="d-inline-flex mb-4">
                                    <img
                                        src="https://cms.growpital.com/uploads/call_88d9fdeb7f.svg"
                                        alt=""
                                        className="img-fluid me-3 mb-4"
                                    />
                                    <a
                                        href="tel:+91-9140636400"
                                        style={{
                                            color: "rgb(7, 229, 125)",
                                            textDecorationColor: "rgb(23, 23, 26)"
                                        }}
                                    >
                                        {" "}
                                        +91-9140636400
                                    </a>
                                </div>
                                <div className="d-inline-flex mb-4 d-flex">
                                    <img
                                        src="https://cms.growpital.com/uploads/ic_baseline_alternate_email_8dcde766bd.svg"
                                        alt=""
                                        className="img-fluid me-3 mb-4"
                                    />
                                    <a
                                        href="mailto:contact@multisphere.in"
                                        style={{
                                            color: "rgb(7, 229, 125)",
                                            textDecorationColor: "rgb(23, 23, 26)"
                                        }}
                                    >
                                        contact@virtual-property.in
                                    </a>
                                </div>
                                <div className="d-inline-flex mb-4">
                                    <img
                                        src="https://cms.growpital.com/uploads/bx_time_b69959fa4b.svg"
                                        alt=""
                                        className="img-fluid me-3 mb-4"
                                    />
                                    <p className="me-5">Mon – Fri : 9:30 – 18:30</p>
                                </div>
                            </div>
                            <div className="me-5 px-2 mb-5 row">
                                {/* <div className=" p-0 col-2">
                                    <a href="https://www.facebook.com/growpital">
                                        <img
                                            src="/static/media/fb.f8d25e0c39b5d81274e5bb5323da78f7.svg"
                                            alt=""
                                        />
                                    </a>
                                </div>
                                <div className=" p-0 col-2">
                                    <a href="https://www.youtube.com/channel/UC01PIsA1RufWKdul_yve63g">
                                        <img
                                            src="/static/media/youtube.04134a64f4d3aff6d1a77f109b5f9e50.svg"
                                            alt=""
                                        />
                                    </a>
                                </div>
                                <div className=" p-0 col-2">
                                    <a href="https://www.linkedin.com/company/growpital/">
                                        <img
                                            src="/static/media/linkdin.02cf9577d3f742f8f1a58e3c47111fdc.svg"
                                            alt=""
                                        />
                                    </a>
                                </div>
                                <div className=" p-0 col-2">
                                    <a href="https://www.instagram.com/growpitalbyzettafarms/">
                                        <img
                                            src="/static/media/insta.e075f7114bec8076c13a87a2ee2f781d.svg"
                                            alt=""
                                        />
                                    </a>
                                </div> */}
                                {/* <div className=" p-0 col-2">
                                    <a href="#">
                                        <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth={0}
                                            viewBox="0 0 16 16"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ fontSize: 32 }}
                                        >
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                                        </svg>
                                    </a>
                                </div> */}
                                <div className=" p-0 col-2">
                                    <a href="https://wa.me/9140636400?text=Hi%20I%20want%20to%20learn%20more%20about%20VirtualProperty.%20">
                                        <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth={0}
                                            viewBox="0 0 16 16"
                                            className="fs-32"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ color: "lightgreen", fontSize: 32 }}
                                        >
                                            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div
                            data-aos="fade-up"
                            className="px-4 px-md-5 col-md-7 aos-init aos-animate"
                        >
                            <div>
                                <h1 className="fs-md-48 fs-40 fw-bold mb-4">Contact Us</h1>
                                <p className="mb-4">
                                    Would you like to speak to one of our financial advisers over the
                                    phone? Just submit your details and we’ll be in touch shortly. You
                                    can also e-mail us for any further concern.
                                </p>
                            </div>
                            <div className="contact-from text-white">
                                <form>
                                    <div className="mb-3 row">
                                        <div className="mb-4 col-12">
                                            <Controller
                                                name={'name'}
                                                control={control}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        placeholder="Name"
                                                        className="form-control"
                                                    />
                                                )}
                                                rules={{
                                                    required: true
                                                }}
                                            />
                                        {errors.name?.type === 'required' && <div className="invalid-feedback">{t.required}</div>}
                                        </div>
                                        <div className="mb-4 col-12">
                                            <Controller
                                                name={'mobile'}
                                                control={control}
                                                rules={{
                                                    required: true,
                                                    minLength: 10,
                                                    maxLength: 10
                                                }}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        placeholder="Mobile"
                                                        type="number"
                                                        className="form-control"
                                                    />
                                                )}
                                                
                                            />
                                            {errors.mobile?.type === 'required' && <div className="invalid-feedback">{t.required}</div>}
                                            {errors.mobile?.type === 'minLength' && <div className="invalid-feedback">{t.minLength}</div>}
                                            {errors.mobile?.type === 'maxLength' && <div className="invalid-feedback">{t.maxLength}</div>}
                                        </div>
                                        <div className="mb-4 col-12">
                                            <Controller
                                                name={'email'}
                                                control={control}
                                                rules={{
                                                    required: true,
                                                    pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/
                                                }}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        placeholder="Email"
                                                        className="form-control"
                                                    />
                                                )}
                                               
                                            />
                                            {errors.email?.type === "required" && <div className="invalid-feedback">{t.required}</div>}
                                            {errors.email?.type === "pattern" && <div className="invalid-feedback">{t.emailError}</div>}
                                       
                                        </div>
                                        <div className="mb-4">
                                            <Controller
                                                name={'message'}
                                                control={control}
                                                render={({ field }) => (
                                                    <textarea
                                                        {...field}
                                                        placeholder="Message"
                                                        rows={3}
                                                        name="message"
                                                        className="form-control"
                                                    />
                                                )}
                                                rules={{
                                                    required: true
                                                }}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="form-check">
                                                <Controller
                                                    name={'acceptedPromotionMails'}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <input
                                                            {...field}
                                                            onClick={(evt) => setValue('acceptedPromotionMails', evt.currentTarget.checked ? 1 : 0)}
                                                            type="checkbox"
                                                            checked={!!field.value}
                                                            className="form-check-input"
                                                        />
                                                    )}
                                                />
                                                <label title="" className="form-check-label">
                                                    You are contacting us to receive transaction , promotions and
                                                    other commercial messages that are relevant to you
                                                </label>
                                                <div className="invalid-feedback">
                                                    {!acceptedPromotionMails && 'You must agree before submitting.'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button onClick={onSubmit} type="button" className="main-btn maincolor mb-2 btn btn-primary">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Notifications
            open={formState.notificationOpen}
            message={formState.notificationMessage}
            onClose={() => { setFormState(prev => { return { ...prev, notificationOpen: false, notificationType: 'error', notificationMessage: '' } }) }}
            severity={formState.notificationType}
        />
    </>)
}